import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import './style.scss';
import { Button } from 'antd';

/**
 *
 */
const UnicommerceAccountForm = ({
  user, setStep, connectToUnicommerce, connectToUnicommerceLoading, unicommerceConnections,
}) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [domainName, setDomainName] = useState('');
  const [clientId, setClientId] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  useEffect(() => {
    if (unicommerceConnections?.success) {
      setUserName(unicommerceConnections?.data?.username);
      setPassword(unicommerceConnections?.data?.password);
      setDomainName(unicommerceConnections?.data?.domain_name);
      setClientId(unicommerceConnections?.data?.client_id);
    }
  }, [unicommerceConnections]);

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (userName && password && domainName && clientId) {
      const payload = {
        username: userName,
        password,
        grant_type: 'password',
        domain_name: domainName,
        client_id: clientId,
        org_id: user?.tenant_info?.org_id,
      };
      connectToUnicommerce(payload, () => {
        setStep(2);
      });
    }
  };

  return (
    <div className="integration-step__wrapper">
      <div className="ant-row">
        <div className="ant-col-md-12">
          <H3FormInput
            name="Username"
            type="text"
            containerClassName="orgInputContainer integration-step-input__wrapper"
            labelClassName="orgFormLabel integration-step-input__label"
            inputClassName="orgFormInput integration-step-input__input"
            placeholder=""
            onChange={(event) => setUserName(event.target.value)}
            value={userName}
            label="Username"
            required
            showError={formSubmitted && !userName}
            disabled={connectToUnicommerceLoading}
            loading={connectToUnicommerceLoading}
          />
        </div>
        <div className="ant-col-md-12" />
        <div className="ant-col-md-12">
          <H3FormInput
            name="Password"
            type="password"
            containerClassName="orgInputContainer integration-step-input__wrapper"
            labelClassName="orgFormLabel integration-step-input__label" 
            inputClassName="orgFormInput integration-step-input__input"
            placeholder=""
            onChange={(event) => setPassword(event.target.value)}
            value={password}
            label="Password"
            required
            showError={formSubmitted && !password}
            disabled={connectToUnicommerceLoading}
            loading={connectToUnicommerceLoading}
          />
        </div>
        <div className="ant-col-md-12" />
        <div className="ant-col-md-12">
          <H3FormInput
            name="Domain Name"
            type="text"
            containerClassName="orgInputContainer integration-step-input__wrapper"
            labelClassName="orgFormLabel integration-step-input__label" 
            inputClassName="orgFormInput integration-step-input__input"
            placeholder=""
            onChange={(event) => setDomainName(event.target.value)}
            value={domainName}
            label="Domain Name"
            required
            showError={formSubmitted && !domainName}
            disabled={connectToUnicommerceLoading}
            loading={connectToUnicommerceLoading}
          />
        </div>
        <div className="ant-col-md-12" />
        <div className="ant-col-md-12">
          <H3FormInput
            name="Client ID"
            type="text"
            containerClassName="orgInputContainer integration-step-input__wrapper"
            labelClassName="orgFormLabel integration-step-input__label" 
            inputClassName="orgFormInput integration-step-input__input"
            placeholder=""
            onChange={(event) => setClientId(event.target.value)}
            value={clientId}
            label="Client ID"
            required
            showError={formSubmitted && !clientId}
            disabled={connectToUnicommerceLoading}
            loading={connectToUnicommerceLoading}
          />
        </div>
        <div className="ant-col-md-12" />
        <div className="ant-col-md-12">
        <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
            <Button
              type="primary"
              ghost
              onClick={() => handleSubmit()}
              loading={connectToUnicommerceLoading}
              disabled={connectToUnicommerceLoading}
            >
              {unicommerceConnections?.success ? 'Change Linked Account' : 'Link Account'}
            </Button>
             &nbsp;&nbsp;
            {unicommerceConnections?.success && (
              <Button
                type="primary"
                onClick={() => setStep(2)}
                loading={connectToUnicommerceLoading}
                disabled={connectToUnicommerceLoading}
              >
                Next Step
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, UnicommerceIntegrationReducers }) => ({
  user: UserReducers.user,
  connectToUnicommerceLoading: UnicommerceIntegrationReducers.connectToUnicommerceLoading,
  unicommerceConnections: UnicommerceIntegrationReducers.unicommerceConnections,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  connectToUnicommerce: (payload, callback) => dispatch(UnicommerceIntegrationActions.connectToUnicommerce(payload, callback)),

});

UnicommerceAccountForm.propTypes = {
  user: PropTypes.any,
  connectToUnicommerce: PropTypes.func,
  connectToUnicommerceLoading: PropTypes.bool,
  setStep: PropTypes.func,
  unicommerceConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceAccountForm));
